export default __webpack_public_path__ + "static/compiled-9472ad91db88a820a218a51eedc9dc69.svg";